import { useTranslation } from 'react-i18next'
import { Home, ArrowLeft } from 'lucide-react'
import { SEO } from '@/components/SEO'
import { Section } from '@/components/Section'
import { Button } from '@/components/ui/Button'
import { LocalizedLink } from '@/components/LocalizedLink'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <>
      <SEO
        title={t('notFound.metaTitle')}
        description={t('notFound.metaDescription')}
        noIndex
      />

      <Section centered>
        <div className="mx-auto max-w-lg text-center">
          <div className="text-9xl font-bold text-primary-200">404</div>
          <h1 className="mt-4 text-3xl font-bold text-secondary-900">
            {t('notFound.title')}
          </h1>
          <p className="mt-4 text-lg text-secondary-600">
            {t('notFound.description')}
          </p>
          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:justify-center">
            <Button
              variant="ghost"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              {t('buttons.goBack')}
            </Button>
            <LocalizedLink to="home">
              <Button variant="primary">
                <Home className="mr-2 h-4 w-4" />
                {t('buttons.backToHome')}
              </Button>
            </LocalizedLink>
          </div>
        </div>
      </Section>
    </>
  )
}
